import React from 'react';
import { DoNotCallList } from '../../../../../../../types/do-not-call-list';
import { OverlayTooltip } from '../../../../../../../../../shared/design-system/components/overlay';
import { getUserTimeZone } from '../../../../../../../../../shared/utils/user-details';
import { getFormattedDate } from '../../../../../../users-and-teams/utils/get-formatted-date';
import { accessibleOnClick } from '../../../../../../../../../shared/utils/accessible-on-click';
import { Action } from '../../../../../../../../../shared/design-system/components/organisms/table/types';
import hasPermission from '../../../../../../../../../shared/utils/access-control/has-permission';
import { Permissions } from '../../../../../../../../../shared/utils/access-control/enums/permissions';

type IProps = {
  doNotCallList: DoNotCallList;
  actions: (Action & { permission?: string })[];
  onAction: (key: string, row: DoNotCallList) => void;
};

const UpdatedAtField: React.FC<IProps> = ({
  doNotCallList,
  actions,
  onAction,
}) => {
  const userTimezone = getUserTimeZone();

  const updatedAtField = (
    <div className="text-cell last-login-cell">
      {getFormattedDate(doNotCallList.updatedAt, userTimezone)}
    </div>
  );

  if (hasPermission(Permissions.DNC_WRITE)) {
    return (
      <div className="hoverable-cell">
        <div className="hoverable-cell--content">{updatedAtField}</div>
        <div className="hoverable-cell--actions actionables">
          {actions.map(
            (action) =>
              hasPermission(action.permission) && (
                <OverlayTooltip text={action.displayName} key={action.key}>
                  <div
                    {...accessibleOnClick(() =>
                      onAction(action.key, doNotCallList),
                    )}
                    className="action-btn"
                  >
                    {action.iconElement}
                  </div>
                </OverlayTooltip>
              ),
          )}
        </div>
      </div>
    );
  }

  return <div className="hoverable-cell">{updatedAtField}</div>;
};

export default UpdatedAtField;
